import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Typography,
} from '@mui/material';
import { CaretDown, Clock } from 'phosphor-react';
import { Fragment, useMemo, useState } from 'react';
import { convertDate } from './TaskList';
import { Strategy } from '../../Utilis/Types/Strategies';
function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant='determinate' {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant='caption'
          component='div'
          color='text.secondary'
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

type Props = {
  strategy: Strategy;
  setSelectedStrategy: (id: string) => void;
  selectedStrategy: string;
};

const StrategySteps = ({
  strategy,
  setSelectedStrategy,
  selectedStrategy,
}: Props) => {
  const [collapsed, setCollapsed] = useState(false);

  const percentage = useMemo(() => {
    let completed = 0;
    const findOne = strategy.steps?.find(
      (item) => item.name === selectedStrategy
    );

    const remaining = findOne?.remainingTasks;

    if (!remaining || remaining === 0) {
      completed = 100;
    } else {
      completed = (1 - remaining / findOne?.tasks.length) * 100;
    }

    return completed;
  }, [selectedStrategy]);

  const handleChange = (name: string) => {
    setSelectedStrategy(name);
  };

  return (
    <Box>
      <Typography
        fontSize={'20px'}
        fontWeight={'600'}
        lineHeight={'24px'}
        color={'#655C68'}
        sx={{
          marginBottom: '16px',
          textOverflow: 'ellipsis',
          maxWidth: '300px',
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
        title={strategy.name}
      >
        {strategy.name}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #E3DDE6',
          borderRadius: '4px',
          padding: '8px 0',
          backgroundColor: 'white',
        }}
      >
        <Box
          borderRadius={'4px'}
          padding={'8px 14px'}
          display={'flex'}
          alignItems={'center'}
          gap={'8px'}
          position={'relative'}
          onClick={() => setCollapsed(!collapsed)}
          sx={{
            cursor: 'pointer',
          }}
        >
          <Typography
            variant='body1'
            color={'#202A2D'}
            fontWeight={'500'}
            fontSize={'16px'}
            lineHeight={'19px'}
          >
            {selectedStrategy}
          </Typography>
          <CaretDown size={18} weight='fill' color={'#736977'} />
          {collapsed && (
            <Box
              bgcolor={'#FFFFFF'}
              border={'1px solid #E3DDE6'}
              borderRadius={'4px'}
              padding={'5px 5px'}
              sx={{
                maxWidth: '100%',
                width: '100%',
                position: 'absolute',
                top: '110%',
                left: '50%',
                transform: 'translate(-50%, 0)',
                zIndex: 1,
              }}
            >
              {
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  gap={'5px'}
                  sx={{ width: '100%' }}
                >
                  {strategy.steps?.map((item, i) => {
                    return (
                      <Fragment key={i}>
                        <Box
                          key={i}
                          onClick={() => handleChange(item.name)}
                          padding={'10px 12px'}
                          mb={'4px'}
                          bgcolor={''}
                          borderRadius={'4px'}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: '#E5FAFF',
                            },
                          }}
                        >
                          <Typography
                            variant='body1'
                            sx={{
                              textDecoration: 'none',
                              color: '#202A2D',
                              fontWeight: 500,
                              fontSize: '14px',
                              textAlign: 'left',
                            }}
                          >
                            {item.name}
                          </Typography>
                        </Box>
                      </Fragment>
                    );
                  })}
                </Box>
              }
            </Box>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '11px' }}>
          <Clock size={20} color='#202A2D' />
          <Typography
            fontSize={'16px'}
            fontWeight={'500'}
            lineHeight={'19px'}
            color={'#202A2D'}
          >
            Target date: {convertDate(strategy.targetDate.toString())}
          </Typography>
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', paddingRight: '8px' }}
        >
          <Typography
            fontSize={'16px'}
            fontWeight={'600'}
            lineHeight={'20px'}
            mr={'8px'}
            color={'#202A2D'}
          >
            Completed
          </Typography>
          <CircularProgressWithLabel
            sx={{
              width: '49px',
              paddingY: '6.5px',
              height: '49px',
              '.MuiTypography-root': {
                fontSize: '14px !important',
                fontWeight: '500 !important',
              },
            }}
            value={percentage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default StrategySteps;
